import { combineReducers } from 'redux';
import myPrivilegesReducer from './myPrivilegesReducer';

export default combineReducers({
  myPrivileges: myPrivilegesReducer,
});
